import { Advice } from '../translations-types';

const translations: Advice = {
  addAdvice: 'Toevoegen Advies-module',
  addAdviceCondition: 'Toevoegen Advies-module conditie',
  addAdviceGroup: 'Toevoegen Advies-module groep',
  adviceName: 'Advies-module naam',
  successfullyUpdated: 'Advies-module update succesvol',
  successfullyCreated: 'Advies-module succesvol aangemaakt',
  createAdvice: 'Aanmaken Advies-module',
  viewAdvice: 'Bekijken advies-module',
  editAdvice: 'Aanpassen advies-module',
  enterNewGroupName: 'Invoeren groepsnaam',
  group: 'Groep',
  adviceConditionName: 'Advies-module conditie naam',
  adviceGroupName: 'Advies-module groepsnaam',
  questions: 'Vragen',
  areYouSureYouWantToDeleteAdviceGroup: 'Wilt u deze Advies-module groep permanent verwijderen?',
  areYouSureYouWantToDeleteAdviceCondition: 'Wilt u deze Advies-module conditie permanent verwijderen?',
  conditions: 'Condities',
  advice: 'Advies-module',
  addOption: 'Toevoegen optie',
  podcastUrl: 'Podcast Url',
  videoUrl: 'Video Url',
  adviceOrUrl: 'Een Advies-module kan tekst en geluidsfragment zijn en/of een Url naar Video of Podcast.',
  watchOnVimeo: 'Bekijk op Vimeo',
  listedOnSpotify: 'Luister op Spotify',
  conditionsOrLogic: 'De Advies-module wordt weergegeven als aan een van deze condities wordt voldaan.',
  groupIsUsedTimes: 'Deze groep is  {{count}} keer gebruikt.',
  conditionIsUsedTimes: 'Deze conditie is {{count}} keer gebruikt.',
  noAdvice: 'Geen Advies-module om weer te geven',
  conditionModalInfoText: 'Conditie is waar als aan alle subcondities wordt voldaan.',
  adviceX: 'Advies-module {{number}}',
  audio: 'Geluidsfragment',
  changeAudio: 'Aanpassen geluidsfragment',
  removeAudio: 'Verwijderen geluidsfragment',
  chooseAudio: 'Kies geluidsfragment',
  generateAdvice: 'Genereer Advies',
  generating: 'Genereren...',
  regenerate: 'Her-genereren',
  generated: 'Gegenereerd',
  resenceAdvice: 'Re-sence Advies',
  assistantsAdvice: 'Assistent Advies',
};

export default translations;
